export default function resourcesReducer(state, action) {
  if (action.type === 'INITIAL_SETUP'
  || action.type === 'ADD_TAG'
  || action.type === 'UPDATE_TAG'
  || action.type === 'ADD_GROUP'
  || action.type === 'UPDATE_GROUP') {
    const tagGroups = state.tagGroups;
    const resources = action.resources || state.resources;
    const groupMap = {};
    tagGroups.forEach((group) => {
      groupMap[group._id] = group;
    });
    const resV = resources.map(res => (
      {
        ...res,
        tags: res.tags.map(tag => (
          groupMap[tag] ? groupMap[tag] : groupMap[tag._id]
        )),
      }
    ));
    return {
      ...state,
      resources: resV,
    };
  } else if (action.type === 'UPDATE_RESOURCE') {
    return {
      ...state,
      resources: state.resources.map((resource) => {
        if (resource._id === action.resource._id) return action.resource;
        return resource;
      }),
    };
  } else if (action.type === 'ADD_RESOURCE') {
    return {
      ...state,
      resources: state.resources.concat([action.resource]),
    };
  } else if (action.type === 'DELETE_GROUP') {
    return {
      ...state,
      resources: state.resources.map(resource => ({
        ...resource,
        tags: resource.tags.filter(tag => (tag._id !== action.groupId)),
      })),
    };
  } else if (action.type === 'DELETE_TAG') {
    return {
      ...state,
      resources: state.resources.map(resource => ({
        ...resource,
        tags: resource.tags.map(group => ({
          ...group,
          tags: group.tags.filter(tag => (tag._id !== action.tagId)),
        })),
      })),
    };
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/resources.js